module.exports = __webpack_public_path__ + "static/media/contact1.25620c1a.jpg";